export default __webpack_public_path__ + "static/media/LETO@FIFOU-3417.58e60426.jpg";